// extracted by mini-css-extract-plugin
export default {"label":"C8oY_4"};